<template>
  <div v-if="resp && resp.detail">
    <div class="S12 T1 title">
      {{ resp.detail.detail.title }}
    </div>
    <div class="S5 T3 marginL30 my-title">
      {{ resp.detail.detail.subTitle }}
    </div>
    <div class="bg sep20"></div>
    <div class="head" v-if="resp.detail.authorInfo">
      <div class="avatarWrap marginL30" @click="goManager()">
        <img :src="resp.detail.authorInfo.headPic" class="avatar" alt="" />
        <img src="../../static/ic_v_log.png" class="log" alt="" />
      </div>
      <div class="marginL30" @click="goManager()">
        <div class="S8 T1">
          {{ resp.detail.authorInfo.name }}
        </div>
        <div class="S4 T3">
          {{ resp.detail.authorInfo.typeName }}
          <template v-if="resp.detail.authorInfo.authorCompany">
            | {{ resp.detail.authorInfo.authorCompany }}
          </template>
        </div>
      </div>
      <div
        class="follow S5 C5"
        :class="resp.detail.authorInfo.isFollowed === 1 ? 'followed' : ''"
        @click="follow()"
      >
        <span>{{
          resp.detail.authorInfo.isFollowed === 1 ? '已关注' : '+关注'
        }}</span>
      </div>
    </div>

    <div v-if="showDetail" id="contentDetail">
      <div v-if="resp.detail.authorInfo" class="S7 T2 desc">
        {{ resp.detail.authorInfo.remark }}
      </div>
      <div class="marginL30 S8 T1 ckjsTitle">课程介绍</div>
      <div class="S7 T2 ckjs">
        {{ resp.detail.detail.description }}
      </div>
      <div class="marginL30 S8 T1 ckjsTitle">订购须知</div>
      <div class="S7 T2 ckjs" v-html="resp.detail.detail.orderRemark"></div>
    </div>
    <div @click="changeDetail" class="arrow-div">
      <van-icon class="arrow-icon T3" name="arrow-down" v-if="!showDetail" />
      <van-icon class="arrow-icon T3" name="arrow-up" v-else />
    </div>
    <div class="B2 sep20" />
    <CourseVideoCatalog
      @playCourseVideo="playCourseVideo"
      @updateSwiper="updateSwiper"
      :contentHeight="contentHeight"
    />
  </div>
</template>

<script>
import CourseVideoCatalog from './CourseVideoCatalog'
import { mapActions, mapState } from 'vuex'
import util from '@/util/util'
import { isGuest } from '@/api/appInfo'
import { hasPermission } from '@/api/permission'
import { Icon } from 'vant'
export default {
  name: 'VideoDetail',
  components: {
    CourseVideoCatalog,
    'van-icon': Icon
  },
  data() {
    return {
      showDetail: true,
      contentHeight: 0
    }
  },
  mounted() {
    setTimeout(() => {
      this.contentHeight =
        document.getElementById('contentDetail')?.clientHeight +
        document.getElementsByClassName('arrow-div')[0].clientHeight / 2
    }, 1000)
  },
  computed: {
    ...mapState('video', ['resp']),
    ...mapState('follow', ['followResp']),

    isPermission() {
      return this.hasPermission(this.resp?.detail?.productId)
    }
  },
  methods: {
    ...mapActions('follow', ['requestfollow']),
    ...mapActions('video', ['requestVideo']),
    hasPermission,

    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },

    follow() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      this.resp.detail.authorInfo.isFollowed =
        this.resp.detail.authorInfo.isFollowed ^ 1
      this.requestfollow({
        authorid: this.resp.detail.authorInfo.authorId,
        follow: this.resp.detail.authorInfo.isFollowed
      })
    },

    goManager() {
      util.go(
        `ycstock://managerDetail?managerId=${this.resp.detail.authorInfo.authorId}`
      )
    },

    playCourseVideo(course) {
      this.$emit('playCourseVideo', course)
    },
    changeDetail() {
      this.showDetail = !this.showDetail
      this.$nextTick(() => {
        this.contentHeight =
          document.getElementById('contentDetail')?.clientHeight || 0
        this.updateSwiper()
      })
    },
    updateSwiper() {
      this.$emit('updateSwiper')
    }
  }
}
</script>

<style scoped lang="scss">
.head {
  align-items: center;
  display: flex;
  padding-top: 50px;
}

.avatarWrap {
  height: 70px;
  width: 70px;
  position: relative;
}

.avatar {
  border-radius: 35px;
  height: 70px;
  width: 70px;
}

.log {
  position: absolute;
  width: 28px;
  height: 28px;
  right: 0;
  bottom: 0;
}

.marginL30 {
  margin-left: 30px;
}

.follow {
  display: flex;
  justify-content: center;
  right: 30px;
  width: 118px;
  position: absolute;
  height: 52px;
  border-radius: 5px;
  border-width: 2px;
  text-align: center;
  border-style: solid;
  border-color: #046bcc;
  align-items: center;
  &.followed {
    border-color: #858585;
    color: #858585;
  }
}

.desc {
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 32px;
  word-wrap: break-word;
}

.ckjsTitle {
  margin-top: 50px;
  margin-bottom: 30px;
}

.ckjs {
  margin-left: 30px;
  margin-right: 30px;
  white-space: pre-wrap;
}

.sep20 {
  height: 20px;
}

.bottom-risk {
  margin-top: 30px;
  padding: 30px;
}
.arrow-div {
  text-align: center;
  padding-bottom: 10px;
  padding-top: 20px;
}
.arrow-icon {
  font-size: 30px;
}
.title {
  margin-top: 40px;
  margin-bottom: 30px;
  margin-left: 30px;
}

.my-title {
  padding-bottom: 40px;
}
.bg {
  background-color: #efeff4;
}
</style>
